import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

import { SECURITY_PROFILE_ENDPOINT } from '../../config/endpoints';
import {
  CLEAR_SECURITY_PROFILE,
  CLEAR_SECURITY_PROFILES,
  FLAG_GETTING_SECURITY_PROFILES,
  FLAG_SECURITY_PROFILE_ACTIVITY,
  GET_SECURITY_PROFILE,
  GET_SECURITY_PROFILES,
} from '../types/security/SecurityProfile';
import { SECURITY_PROFILE_PATH } from '../../config/paths';
import { push } from 'react-router-redux';

const flagGettingSecurityProfiles = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_SECURITY_PROFILES,
    payload: flag,
  });

const flagSecurityProfileActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_SECURITY_PROFILE_ACTIVITY,
    payload: flag,
  });

const getSecurityProfile = async ({id}) => async (dispatch) => {
  dispatch(flagSecurityProfileActivity(true));
  try {
    const url = `${SECURITY_PROFILE_ENDPOINT}/${id}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const securityProfile = await response.json();
    dispatch({
      type: GET_SECURITY_PROFILE,
      payload: securityProfile,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagSecurityProfileActivity(false));
  }
};


const clearSecurityProfile = () => (dispatch) =>
  dispatch({
    type: CLEAR_SECURITY_PROFILE,
  });
  
  const getSecurityProfiles = async (tableFilters) => async (dispatch) => {
    try {
      dispatch(flagGettingSecurityProfiles(true));
      const query = tableFilters;
      const url = `${SECURITY_PROFILE_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_SECURITY_PROFILES,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingSecurityProfiles(false));
  }
};

const clearSecurityProfiles = () => (dispatch) =>
  dispatch({
    type: CLEAR_SECURITY_PROFILES,
  });

  
const postSecurityProfile = (data) => async (dispatch) => {
  dispatch(flagSecurityProfileActivity(true));
  try {
    const response = await fetch(SECURITY_PROFILE_ENDPOINT, {
      ...DEFAULT_POST_CONFIG,
      method: 'POST',
      body: JSON.stringify(data),
    });
    await isErrorResponse(response, null, dispatch);
    await response.json();
    dispatch(push(SECURITY_PROFILE_PATH));
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagSecurityProfileActivity(false));
  }
};

const deleteSecurityProfile =
  async ({ securityProfileId }) =>
  async (dispatch) => {
    try {
      dispatch(flagSecurityProfileActivity(true));
      const url = `${SECURITY_PROFILE_ENDPOINT}/${securityProfileId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      }).then((res) => res);
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(SECURITY_PROFILE_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagSecurityProfileActivity(false));
    }
  };

  const putSecurityProfile =
  async ( securityProfileId, data) =>
  async (dispatch) => {
    try {
      dispatch(flagSecurityProfileActivity(true));
      const payload = {
        id: securityProfileId,
        ...data,
      };
      const url = `${SECURITY_PROFILE_ENDPOINT}/${securityProfileId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${SECURITY_PROFILE_PATH}/${securityProfileId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagSecurityProfileActivity(false));
    }
  };

  export {
  getSecurityProfiles,
  clearSecurityProfiles,
  getSecurityProfile,
  clearSecurityProfile,
  postSecurityProfile,
  deleteSecurityProfile,
  putSecurityProfile
};
